import { makeApiCall } from "../apiRequest";

export default {
  state: {
    planList: [],
    SavePlanList: [],
    // Subscription plan limits (maxRooms, maxEmployees, etc.)
    planLimitList: [],
  },
  getters: {
    getPlan: (state) => state.planList,
    Saveplan: (state) => state.SavePlanList,
    // Expose subscription plan limits
    getPlanLimits: (state) => state.planLimitList,
  },
  actions: {
    async getPlan({ commit }, payload) {
      const response = await makeApiCall(
        "subscriptionPlan/getAll",
        "POST",
        payload
      );
      if (!response.error) {
        commit("setPlanList", response.data.data);
      }
      return response;
    },
    // Fetch subscription plan limits
    async getSubscriptionPlansLimit({ commit }, payload) {
      const response = await makeApiCall(
        "subscriptionPlan/getSubscriptionPlansLimit",
        "POST",
        payload
      );
      if (!response.error) {
        commit("setPlanLimitList", response.data.data);
      }
      return response;
    },
    async saveplan({ commit }, payload) {
      const response = await makeApiCall(
        "subscriptionPlan/save",
        "POST",
        payload
      );
      if (!response.error) {
        commit("setSavePlanList", response.data.data);
      }
      return response;
    },
  },
  mutations: {
    setPlanList(state, payload) {
      state.planList = payload;
    },
    setPlanLimitList(state, payload) {
      state.planLimitList = payload;
    },
    setSavePlanList(state, payload) {
      state.SavePlanList = payload;
    },
  },
};
